<template>
  <section
    id="amazon"
    class="te-bg-banner-amazon bg-cover bg-center px-4 py-6"
  >
    <!-- 左上の円 -->
    <div class="te-amazon-box relative mx-auto">
      <span class="te-amazon-circle absolute flex items-center justify-center rounded-full font-bold leading-normal text-white">
        もれなく
        <br>
        もらえる
      </span>
    </div>

    <!-- 白背景部分 -->
    <div class="te-amazon-box te-amazon-box-inner relative mx-auto overflow-hidden rounded bg-white px-4 pb-5 pt-4 text-center md:py-6">
      <h2 class="te-amazon-title-sub mb-0 leading-base">
        <slot name="title">
          無料相談に参加して
        </slot>
      </h2>
      <h3 class="te-amazon-text-orange mb-0 font-bold leading-normal">
        <span class="te-amazon-title-amazon pr-1 text-co-gray-700">amazon</span>
        <span class="te-amazon-title-giftcard">ギフトカード</span>
        <br class="block md:hidden">
        <span class="te-amazon-title-fee font-bold">500</span>
        <span class="co-display-8 font-bold">円分</span>
      </h3>
    </div>
  </section>
</template>

<style scoped>
.te-bg-banner-amazon {
  background-image: url('~/assets/images/Te/TeCounseling/AmazonGift/bg_concentrated_line.png');
}

.te-amazon-box {
  max-width: 41.4375rem;
}

/* 左上の円 */
.te-amazon-circle {
  top: -1rem;
  left: -0.5rem;
  z-index: 1;
  width: 4.75rem;
  height: 4.75rem;
  font-size: 0.875rem;
  background-color: #fe8282;
}

/* 白背景部分 */
.te-amazon-box-inner {
  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    display: block;
    width: 10rem;
    height: 2.1875rem;
    content: '';
    background: #ff8181;
    transform: rotate(-45deg) translate(48px, 38px);
  }
}

.te-amazon-title-sub {
  font-size: 1.125rem;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

.te-amazon-text-orange {
  color: #f99029;
}

.te-amazon-title-amazon {
  font-size: 2.25rem;
  @media (min-width: 768px) {
    font-size: 3rem;
  }
}

.te-amazon-title-giftcard {
  font-size: 1.625rem;
  @media (max-width: 767.98px) {
    letter-spacing: -0.0488rem;
  }
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}

.te-amazon-title-fee {
  font-size: 2.25rem;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
}
</style>
